<template>
  <el-row :gutter="10">
    <el-col :span="12" style="margin: 5px 0">
      <p class="card-p">Location distribution of ASMs</p>
      <StatisticsChart1></StatisticsChart1>
    </el-col>
    <el-col :span="12" style="margin: 5px 0">
      <p class="card-p">Statistics of distances between index SNV and CpG</p>
      <StatisticsChart2></StatisticsChart2>
    </el-col>
  </el-row>
  <el-row :gutter="10">
    <el-col :span="12" style="margin: 5px 0">
      <p class="card-p">The distribution of ASM across the genome</p>
      <StatisticsChart4></StatisticsChart4>
    </el-col>
    <el-col :span="12" style="margin: 5px 0">
      <p class="card-p">Distribution of ASMs among regulatory elements</p>
      <img src="../assets/statistics/statistic1.jpg" style="width: 700px;height: 500px"/>
    </el-col>
  </el-row>
  <el-row>
    <el-col :span="14" style="margin: 5px 0">
      <p class="card-p">Statistics for CpG-SNV pairs</p>
      <StatisticsChart5/>
    </el-col>
    <el-col :span="10" style="margin: 5px 0">
      <p class="card-p">Distribution of methylation change at ASM sites</p>
      <StatisticsChart3></StatisticsChart3>
    </el-col>
  </el-row>
</template>

<script>
import StatisticsChart1 from "@/components/chart/statistics_chart1.vue"
import StatisticsChart2 from "@/components/chart/statistics_chart2.vue"
import StatisticsChart3 from "@/components/chart/statistics_chart3.vue"
import StatisticsChart4 from "@/components/chart/statistics_chart4.vue"
import StatisticsChart5 from "@/components/statistics/StatisticsChart5";
export default {
  name: "statistics_page",
  components: {StatisticsChart5, StatisticsChart1,StatisticsChart2,StatisticsChart3,StatisticsChart4}
}
</script>

<style scoped>
::v-deep .card-p{
  text-align: center;
  position: relative;
  z-index: 20;
  font-size: 20px;
}
</style>
